<rt-dropdown [width]="DropdownWidth.FullWidth">
  <rt-group variant="horizontal">
    <rt-icon-button
      [rtTooltip]="'wysiwyg.bulletslist' | translate"
      [pressed]="getActive() === NodeName.BulletList"
      (click)="unorderedClick()"
      variant="plain"
      size="small"
      iconName="format-list-bulleted"
    ></rt-icon-button>
    <rt-icon-button
      [rtTooltip]="'wysiwyg.numberslist' | translate"
      [pressed]="getActive() === NodeName.OrderedList"
      (click)="orderedClick()"
      variant="plain"
      size="small"
      iconName="format-list-numbered"
    ></rt-icon-button> </rt-group
></rt-dropdown>
